export interface FilmNews {
  id: string;
  title: string;
  summary: string;
  date: string;
  filmId: string;
  tag: string;
}

export const filmNews: FilmNews[] = [
  {
    id: "n001",
    title: "《荒野信使》斩获年度最佳剧情片，主创分享幕后拍摄故事",
    summary: "在刚刚落幕的年度影视盛典上，《荒原信使》凭借克制而深情的叙事拿下最佳剧情片。导演陈墨川透露，片中大部分沙漠场景均为实景拍摄，团队为此在西部边缘驻扎了整整四十天。",
    date: "2024-10-12",
    filmId: "f001",
    tag: "获奖",
  },
  {
    id: "n002",
    title: "《归途列车》迎来大结局，观众集体回忆自己的春运故事",
    summary: "陪伴观众一整年的家庭年代剧《归途列车》于本周收官。大结局当晚相关话题迅速登顶热搜，无数观众在评论区分享自己与绿皮火车、与家人的记忆。",
    date: "2024-10-08",
    filmId: "f003",
    tag: "热播",
  },
  {
    id: "n003",
    title: "科幻灾难片《深海回响》发布全新预告，深海场景引发热议",
    summary: "《深海回响》释出第二支预告片，片中海沟勘探的压迫感与未知声波的神秘氛围获得大量好评。据悉，影片的特效团队为还原深海环境耗时两年搭建了全新的水下渲染方案。",
    date: "2024-10-05",
    filmId: "f012",
    tag: "预告",
  },
  {
    id: "n004",
    title: "《城市之光》登陆流媒体，悬疑口碑再度发酵",
    summary: "上线两年后，《城市之光》仍凭借扎实的剧本和细腻的表演持续吸引新观众。此次登陆主流流媒体平台后，关于“那盏没亮起的灯”的讨论再一次刷屏。",
    date: "2024-09-29",
    filmId: "f002",
    tag: "上线",
  },
  {
    id: "n005",
    title: "《山河故人志》剧组重聚，宣布历史题材新篇章",
    summary: "《山河故人志》主创团队在一场文化访谈中罕见重聚，编剧透露正在筹备同一历史背景下的全新篇章，将继续以群像方式探讨文明与个体的关系。",
    date: "2024-09-24",
    filmId: "f007",
    tag: "新项目",
  },
  {
    id: "n006",
    title: "《星尘旅途》定档春季，终极海报首度公开",
    summary: "备受期待的太空冒险片《星尘旅途》正式定档明年春季，同步释出的终极海报以一艘孤舟驶向金色星云的画面，精准传达了影片“孤独而温柔”的气质。",
    date: "2024-09-18",
    filmId: "f010",
    tag: "定档",
  },
  {
    id: "n007",
    title: "青春励志剧《逆风飞翔》口碑逆袭，校园题材再受关注",
    summary: "开播时并不被看好的《逆风飞翔》，凭借拒绝开挂、扎实写实的叙事实现口碑逆袭。许多观众表示，剧中主角的每一次跌倒都让人想起自己的高中时代。",
    date: "2024-09-11",
    filmId: "f008",
    tag: "口碑",
  },
  {
    id: "n008",
    title: "《樱色的夏天》重制版上线，纯爱经典再掀怀旧潮",
    summary: "播出一年后，《樱色的夏天》推出画面重制版本，樱花季节的色调被进一步优化。重制版上线首周便重回热度榜前列，证明纯粹的情感永远有市场。",
    date: "2024-09-02",
    filmId: "f005",
    tag: "重制",
  },
];